import { Identifiable, ProjectResource } from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function activateProjectResource(httpClient: HttpClient, linker: Linker) {
  return (
    resource: Identifiable<ProjectResource>,
    nextResource: ProjectResource,
  ) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<ProjectResource>>>({
        endpoint: `/projectMembers/${resource.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          deactivated: false,
        },
      })
      .then(linker.linkProjectResource);
}

export { activateProjectResource };
